export default __webpack_public_path__ + "static/media/eagle drop 1.3c8d5842.svg";